import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addProductToOrder } from '../../store/slices/wholesaleOrderSlice';
import { showAlert } from '../../store/slices/alertSlice';
import { setLoadSuccess, setLoadFailure } from '../../store/slices/wholesaleInventorySlice';
import { useFetchWholesaleInventory } from './wholesaleuser.hooks';

import {
  CircularProgress,
  Box,
  Button,
  TextField,
  Modal,
  Typography,Stack
} from '@mui/material';

export default function AddProduct() {
  const [productCode, setProductCode] = useState('');
  const [isSearching, setIsSearching] = useState(false);
  const dispatch = useDispatch();
  const triggerSearchRef = useRef(false);

  const { loadItems: loadDetails } = useSelector((state) => state.load);
  const { refetch } = useFetchWholesaleInventory({ enabled: false });
  const hasLoad = Array.isArray(loadDetails) && loadDetails.length > 0;

  useEffect(() => {
    const fetchData = async () => {
      if (!hasLoad) {
        const result = await refetch();
        if (result.status === 'success' && result.data && result.data.inventories) {
          dispatch(setLoadSuccess(result.data.inventories));
        } else if (result.status === 'error') {
          dispatch(setLoadFailure(result.error?.message || 'Failed to fetch wholesale inventory' ));
          dispatch(showAlert({ severity: 'error', title: result.error?.message || 'Failed to fetch wholesale inventory' }));
        }
      }
    };
    fetchData();
  }, [hasLoad, refetch, dispatch]);

  useEffect(() => {
    if (triggerSearchRef.current && productCode) {
      triggerSearchRef.current = false;
      handleFetchProduct();
    }
  }, [productCode]);

  const handleFetchProduct = async () => {
    if (!productCode.trim()) {
      dispatch(showAlert({ severity: 'warning', title: 'Please enter a product code.' }));
      return;
    }

    if (!loadDetails?.length) {
      dispatch(showAlert({ severity: 'error', title: 'No inventory details available.' }));
      return;
    }

    setIsSearching(true);

    const matchedProduct = loadDetails.find(
      (item) => item.productcode?.toLowerCase() === productCode.trim().toLowerCase()
    );

    if (matchedProduct) {
      dispatch(addProductToOrder(matchedProduct));
      dispatch(showAlert({ severity: 'success', title: 'Product added.' }));
      setProductCode('');
    } else {
      dispatch(showAlert({ severity: 'error', title: 'Product not found wholesale inventory' }));
    }

    setIsSearching(false);
  };



  return (
    <>
      <Stack direction="row" spacing={2} mt={2} alignItems="stretch">
        <TextField
         placeholder="Product Code"
          value={productCode}
          onChange={(e) => setProductCode(e.target.value)}
          disabled={isSearching}
           variant="outlined" size="small"
        />
        <Button
          onClick={handleFetchProduct}
          variant="contained" size="small"
          disabled={isSearching}
          startIcon={isSearching ? <CircularProgress size={20} color="inherit" /> : null}
        >
          {isSearching ? 'Searching...' : 'Add Product'}
        </Button>

      </Stack>

    </>
  );
}
